import React from 'react';
import * as Icon from 'react-feather';

// {
//     title: 'AI Callex',
//     id: 'ai-callex',
//     icon: <Icon.Cpu size={20} />,
//     href: '/ai-callex',
//     collapisble: true,
//     subItems: [
//       {
//         title: 'Reports',
//         id: 'ai-callex-reports',
//         subItems: [
//           {
//             title: 'AI Real Time Report',
//             href: '/ai-callex/reports/ai-realtime-report',
//             permissionKey: 'AI Real Time Report',
//             id: 201
//           },
//           {
//             title: 'Call Logs',
//             href: '/ai-callex/reports/ai-call-logs',
//             permissionKey: 'Call Logs',
//             id: 18
//           }
//         ]
//       },
//       {
//         title: 'AI',
//         id: 46,
//         subItems: [
//           {
//             title: 'AI Agents',
//             href: '/ai-callex/ai/ai-agents',
//             permissionKey: 'AI Agents',
//             id: 47
//           },
//           {
//             title: 'AI Phone number',
//             href: '/ai-callex/ai/ai-phone-number',
//             permissionKey: 'AI Phone Number',
//             id: 48
//           },
//           {
//             title: 'AI Keys',
//             href: '/ai-callex/ai/ai-key',
//             permissionKey: 'AI Key',
//             id: 200
//           }
//         ]
//       },
//       {
//         title: 'Settings',
//         id: 'ai-callex-settings',
//         subItems: [
//           {
//             title: 'AI Disposition',
//             href: '/ai-callex/settings/ai-disposition',
//             permissionKey: 'AI Disposition',
//             id: 202
//           }
//         ]
//       }
//     ]
//   };

export const SidebarData = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    id: 'dashboard',
    i18nTitle: 'dashboard',
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  // {
  //   title: 'Call Summary',
  //   href: '/call-summary',
  //   id: 2,
  //   icon: <Icon.BarChart size={20} />,
  //   collapisble: false
  // },
  // {
  //   title: 'My Callbacks',
  //   href: '/my-callbacks',
  //   id: 3,
  //   icon: <Icon.PhoneForwarded size={20} />,
  //   collapisble: false
  // },
  // {
  //   title: 'My Call History',
  //   href: '/my-callhistory',
  //   id: 'my-callhistory',
  //   i18nTitle: 'liveCallHistory',
  //   icon: <Icon.PhoneCall size={20} />,
  //   collapisble: false
  // },
  {
    title: 'My Reports',
    href: '/my-reports',
    id: 'my-reports',
    i18nTitle: 'myReports',
    icon: <Icon.PhoneCall size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Reports',
        i18nTitle: 'reports',
        id: 'reports',
        subItems: [
          {
            title: 'My Call History',
            i18nTitle: 'liveCallHistory',
            href: '/my-reports/my-callhistory',
            id: 'my-callhistory'
          },
          {
            title: 'My Missed Call Report',
            i18nTitle: 'myMissedCallReport',
            href: '/my-reports/my-missed-call-report',
            id: 'my-missed-call-report'
          }
        ]
      }
    ]
  },
  {
    title: 'Follow Up',
    href: '/follow-up',
    id: 'follow-up',
    i18nTitle: 'followUp',
    icon: <Icon.Clock size={20} />,
    collapisble: false
  }
  // {
  //   title: 'Meta Help Desk',
  //   href: '/meta-help-desk',
  //   id: 'meta-help-desk',
  //   i18nTitle: 'metaHelpDesk',
  //   icon: <Icon.BookOpen size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'Help Desk',
  //   href: '/help-desk',
  //   id: 6,
  //   icon: <Icon.HelpCircle size={20} />,
  //   collapisble: false
  // }
];

export const CrmSideBarData = [
  {
    title: 'CRM',
    href: '/crm',
    id: 'crm',
    i18nTitle: 'crm',
    icon: <Icon.Users size={20} />,
    collapisble: false
  },
  {
    title: 'Chat Bot',
    href: '/chat-bot',
    id: 'chat-bot',
    i18nTitle: 'chatBot',
    icon: <Icon.Headphones size={20} />,
    collapisble: false
  }
  // {
  //   title: 'Help Desk',
  //   href: '/help-desk',
  //   id: 6,
  //   icon: <Icon.HelpCircle size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'product',
  //   href: '/product',
  //   id: 2,
  //   icon: <Icon.Package size={20} />,
  //   collapisble: false
  // }
  // {
  //   title: 'Call Summary',
  //   href: '/call-summary',
  //   id: 2,
  //   icon: <Icon.BarChart size={20} />,
  //   collapisble: false
  // },
  // {
  //   title: 'Comments',
  //   href: '/comments',
  //   id: 3,
  //   icon: <Icon.MessageCircle size={20} />,
  //   collapisble: false
  // }
];

export const TenantSidebarData = [
  {
    title: 'Dashboard',
    href: '/tenant-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Server Health',
    href: '/server-health',
    id: 'server-health',
    icon: <Icon.Activity size={20} />,
    permissionKey: 'Server Health',
    collapisble: false
  },
  {
    title: 'Reports',
    id: 2,
    href: '/reports',
    icon: <Icon.FileText size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Live Report',
        id: 3,
        subItems: [
          {
            title: 'Realtime Report',
            href: '/reports/realtime-report',
            permissionKey: 'Real Time Report',
            id: 4
          },
          {
            title: 'Voice Broadcast Report',
            href: '/reports/broadcast-report',
            permissionKey: 'Voice Broadcast Report',
            id: 5
          }
        ]
      },
      {
        title: 'Call Details Report',
        id: 6,
        subItems: [
          {
            title: 'Daily Report',
            href: '/reports/daily-report',
            permissionKey: 'Daily Report',
            id: 7
          },
          {
            title: 'Dump Report',
            href: '/reports/dump-report',
            permissionKey: 'Dump Report',
            id: 8
          }
        ]
      },
      {
        title: 'Agent Performance',
        id: 9,
        subItems: [
          {
            title: 'Daily Agent Login Logout',
            href: '/reports/daily-agent-login-logout',
            permissionKey: 'Daily Agent Login Logout',
            id: 10
          },
          {
            title: 'Custom Agent Login Logout',
            href: '/reports/custom-agent-login-logout',
            permissionKey: 'Custom Agent Login Logout',
            id: 11
          }
        ]
      },
      {
        title: 'Download',
        id: 12,
        subItems: [
          {
            title: 'Recording Report',
            href: '/reports/recording-report',
            permissionKey: 'Recording Report',
            id: 13
          },
          {
            title: 'Both Legs Report',
            href: '/reports/both-legs-report',
            permissionKey: 'Both Legs Report',
            id: 13.1
          }
        ]
      },
      {
        title: 'DID Report',
        id: 14,
        subItems: [
          {
            title: 'DID Daily Report',
            href: '/reports/did-daily-report',
            permissionKey: 'DID Daily Report',
            id: 15
          },
          {
            title: 'DID Dump Report',
            href: '/reports/did-dump-report',
            permissionKey: 'DID Dump Report',
            id: 16
          }
        ]
      },
      {
        title: 'Product',
        id: 19,
        subItems: [
          {
            title: 'Product Report',
            href: '/reports/product-report',
            permissionKey: 'Product Report',
            id: 20
          }
        ]
      },
      {
        title: 'Voice Broadcast',
        id: 21,
        subItems: [
          {
            title: 'DTMF Report',
            href: '/reports/dtmf-report',
            permissionKey: 'DTMF Report',
            id: 22
          },
          {
            title: 'Call Connectivity Report',
            href: '/reports/call-connectivity-report',
            permissionKey: 'Call Connectivity Report',
            id: 23
          },
          {
            // Must match module_permission.module_name exactly — Header.jsx
            // compares them as strings, so a rename on either side hides this
            // menu silently. Seeded by the prepaid-billing migration.
            title: 'Credit Report',
            href: '/reports/vb-credit-report',
            permissionKey: 'VoiceBroadcast Credit Report',
            id: 24
          }
        ]
      },
      {
        title: 'Call Report',
        id: 24,
        subItems: [
          {
            title: 'Missed Call Report',
            href: '/reports/missed-call-report',
            permissionKey: 'Missed Call Report',
            id: 25
          },
          {
            title: 'Agent Performance Report',
            href: '/reports/agent-performance-report',
            permissionKey: 'Agent Performance Report',
            id: 26
          },
          {
            title: 'Agent Disposition Report',
            href: '/reports/agent-disposition-report',
            permissionKey: 'Agent Disposition Report',
            id: 27
          },
          // Kept for future use - currently opened as a modal from Agent Disposition Report
          // {
          //   title: 'Disposition Details Report',
          //   href: '/reports/disposition-details-report',
          //   permissionKey: 'Disposition Details Report',
          //   id: 211
          // },
          {
            title: 'Audit Report',
            href: '/reports/tenant-audit-report',
            permissionKey: 'Audit Report',
            id: 28
          }
        ]
      },
      {
        title: 'Lead Report',
        id: 92,
        subItems: [
          {
            title: 'Lead Retries Report',
            href: '/reports/lead-retries-report',
            permissionKey: 'Lead Retries Report',
            id: 93
          }
        ]
      },
      {
        title: 'Omni Channel Report',
        id: 29,
        subItems: [
          {
            title: 'Chat Report',
            href: '/reports/chat-report',
            permissionKey: 'Chat Report',
            id: 30
          },
          {
            title: 'Whatsapp Report',
            href: '/reports/whatsapp-report',
            permissionKey: 'Whatsapp Report',
            id: 31
          }
        ]
      },
      {
        title: 'Auditor',
        id: 32,
        subItems: [
          {
            title: 'Auditor Dashboard',
            href: '/reports/auditor-dashboard',
            permissionKey: 'Auditor Dashboard',
            id: 33
          },
          {
            title: 'Auditor Report',
            href: '/reports/auditor-report',
            permissionKey: 'Auditor Report',
            id: 34
          }
        ]
      }
    ]
  },
  {
    title: 'Configuration',
    id: 35,
    href: '/configuration',
    icon: <Icon.Settings size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Config',
        id: 36,
        subItems: [
          {
            title: 'Crms',
            href: '/configuration/crms',
            permissionKey: 'Crms',
            id: 37
          },
          {
            title: 'Users',
            href: '/configuration/users',
            permissionKey: 'Users',
            id: 38
          },
          {
            title: 'Process',
            href: '/configuration/process',
            permissionKey: 'Process',
            id: 39
          },
          {
            title: 'Lists',
            href: '/configuration/lists',
            permissionKey: 'Lists',
            id: 40
          },
          {
            title: 'Lead Retries',
            href: '/configuration/lead-retries',
            permissionKey: 'Lead Retries',
            id: 41
          },
          {
            title: 'DNC',
            href: '/configuration/dnc',
            permissionKey: 'DNC',
            id: 42
          },
          {
            title: 'Whatsapp Meta',
            href: '/configuration/whatsapp-meta',
            permissionKey: 'Whatsapp Meta',
            id: 43
          },
          {
            title: 'SMTP',
            href: '/configuration/smtp',
            permissionKey: 'SMTP',
            id: 44
          },
          {
            title: 'Hot Key',
            href: '/configuration/hot-key',
            permissionKey: 'Hot Key',
            id: 45
          }
        ]
      },
      {
        title: 'Setting',
        id: 49,
        subItems: [
          {
            title: 'Disposition',
            href: '/configuration/setting/disposition',
            permissionKey: 'Disposition',
            id: 50
          },
          {
            title: 'Sub Disposition',
            href: '/configuration/setting/sub-disposition',
            permissionKey: 'Sub Disposition',
            id: 51
          },
          {
            title: 'Sub Sub Disposition',
            href: '/configuration/setting/sub-sub-disposition',
            permissionKey: 'Sub Sub Disposition',
            id: 52
          },
          {
            title: 'Breaks',
            href: '/configuration/setting/breaks',
            permissionKey: 'Breaks',
            id: 53
          },
          {
            title: 'PBX DTMF',
            href: '/configuration/setting/pbx-dtmf',
            permissionKey: 'PBX DTMF',
            id: 203
          },
          {
            title: 'Scripts',
            href: '/configuration/setting/scripts',
            permissionKey: 'Scripts',
            id: 54
          }
        ]
      },
      {
        title: 'Routing',
        id: 55,
        subItems: [
          {
            title: 'Trunks',
            href: '/configuration/routing/trunks',
            permissionKey: 'Trunks',
            id: 56
          },
          {
            title: 'Outbound Routes',
            href: '/configuration/routing/outbound',
            permissionKey: 'Outbound Routes',
            id: 57
          }
        ]
      },
      {
        title: 'Product',
        id: 58,
        subItems: [
          {
            title: 'Area',
            href: '/configuration/product/area',
            permissionKey: 'Area',
            id: 59
          },
          {
            title: 'Beat',
            href: '/configuration/product/beat',
            permissionKey: 'Beat',
            id: 60
          },
          {
            title: 'Outlet',
            href: '/configuration/product/outlet',
            permissionKey: 'Outlet',
            id: 61
          },
          {
            title: 'Product',
            href: '/configuration/product/lists',
            permissionKey: 'Product',
            id: 62
          }
        ]
      },
      {
        title: 'Omni Channel',
        id: 63,
        subItems: [
          {
            title: 'Whatsapp',
            href: '/configuration/omni-channel/whatsapp',
            permissionKey: 'Whatsapp',
            id: 64
          },
          {
            title: 'Whatsapp Templates',
            href: '/configuration/omni-channel/whatsapp-templates',
            permissionKey: 'Whatsapp Templates',
            id: 65
          },
          {
            title: 'Whatsapp Broadcast',
            href: '/configuration/omni-channel/whatsapp-broadcast',
            permissionKey: 'Whatsapp Broadcast',
            id: 66
          },
          {
            title: 'Whatsapp Redirect Message',
            href: '/configuration/omni-channel/whatsapp-redirect-message',
            permissionKey: 'Whatsapp Redirect Message',
            id: 213
          }
        ]
      },
      {
        title: 'Whatsapp Bot',
        id: 67,
        subItems: [
          {
            title: 'Whatsapp Bot Template',
            href: '/configuration/whatsapp-bot/template',
            permissionKey: 'Whatsapp Bot Template',
            id: 68
          },
          {
            title: 'Whatsapp Bot Flow',
            href: '/configuration/whatsapp-bot/flow',
            permissionKey: 'Whatsapp Bot Flow',
            id: 69
          },
          {
            title: 'Whatsapp Bot Broadcast',
            href: '/configuration/whatsapp-bot/broadcast',
            permissionKey: 'Whatsapp Bot Broadcast',
            id: 70
          }
        ]
      },
      {
        title: 'Whatsapp Meta',
        id: 71,
        subItems: [
          {
            title: 'Whatsapp Meta Template',
            href: '/configuration/whatsapp-meta/template',
            permissionKey: 'Whatsapp Meta Template',
            id: 72
          },
          {
            title: 'Whatsapp Meta Flow',
            href: '/configuration/whatsapp-meta/flow',
            permissionKey: 'Whatsapp Meta Flow',
            id: 73
          },
          {
            title: 'Whatsapp Meta Broadcast',
            href: '/configuration/whatsapp-meta/broadcast',
            permissionKey: 'Whatsapp Meta Broadcast',
            id: 74
          }
        ]
      },
      {
        title: 'Follow Up',
        id: 75,
        subItems: [
          {
            title: 'Follow Up',
            href: '/configuration/follow-up',
            permissionKey: 'Follow Up',
            id: 76
          }
        ]
      }
    ]
  },
  {
    title: 'AI Callex',
    id: 'ai-callex',
    icon: <Icon.Cpu size={20} />,
    href: '/ai-callex',
    collapisble: true,
    subItems: [
      {
        title: 'Reports',
        id: 'ai-callex-reports',
        subItems: [
          {
            title: 'AI Real Time Report',
            href: '/ai-callex/reports/ai-realtime-report',
            permissionKey: 'AI Real Time Report',
            id: 201
          },
          // {
          //   title: 'Call Logs',
          //   href: '/ai-callex/reports/callex-ai-call-logs',
          //   permissionKey: 'Call Logs',
          //   id: 18
          // },
          {
            title: 'AI CDRs',
            href: '/ai-callex/reports/ai-cdrs',
            permissionKey: 'AI CDRs',
            id: 205
          },
          {
            title: 'AI Recording',
            href: '/ai-callex/reports/ai-recording',
            permissionKey: 'AI Recording',
            id: 208
          },
          {
            title: 'Credit Report',
            href: '/ai-callex/reports/credit-report',
            permissionKey: 'Credit Report',
            id: 209
          }
        ]
      },
      {
        title: 'AI',
        id: 46,
        subItems: [
          {
            title: 'AI Agents',
            href: '/ai-callex/ai/callex-ai-agents',
            permissionKey: 'AI Agents',
            id: 47
          },
          {
            title: 'AI Keys',
            href: '/ai-callex/ai/ai-key',
            permissionKey: 'AI Key',
            id: 200
          },
          {
            title: 'Bot Voices',
            href: '/ai-callex/ai/bot-voices',
            permissionKey: 'Bot Voices',
            id: 203
          },
          {
            title: 'Bot RAG',
            href: '/ai-callex/ai/bot-rag',
            permissionKey: 'Bot RAG',
            id: 204
          },
          {
            title: 'Bot SIP Routing',
            href: '/ai-callex/ai/bot-sip-routing',
            permissionKey: 'Bot SIP Routing',
            id: 207
          }
        ]
      },
      {
        title: 'Settings',
        id: 'ai-callex-settings',
        subItems: [
          {
            title: 'AI Disposition',
            href: '/ai-callex/settings/ai-disposition',
            permissionKey: 'AI Disposition',
            id: 202
          },
          {
            title: 'Allow IP',
            href: '/ai-callex/settings/allow-ip',
            permissionKey: 'Allow IP',
            id: 206
          }
        ]
      }
    ]
  },
  {
    title: 'Incoming',
    id: 77,
    href: '/incoming',
    icon: <Icon.PhoneIncoming size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Incoming',
        id: 78,
        subItems: [
          {
            title: 'DIDs',
            href: '/incoming/did',
            permissionKey: 'DIDs',
            id: 79
          },
          {
            title: 'Queues',
            href: '/incoming/queues',
            permissionKey: 'Queues',
            id: 80
          },
          {
            title: 'IVRs',
            href: '/incoming/ivr',
            permissionKey: 'IVRs',
            id: 81
          },
          {
            title: 'Dynamic IVRs',
            href: '/incoming/dynamic-ivr',
            permissionKey: 'Dynamic IVRs',
            id: 210
          },
          {
            title: 'Inbound ACL',
            href: '/incoming/inbound-acl',
            permissionKey: 'Inbound ACL',
            id: 212
          }
        ]
      },
      {
        title: 'Prompts',
        id: 82,
        subItems: [
          {
            title: 'Audio Prompts',
            href: '/incoming/prompts/audio-prompts',
            permissionKey: 'Audio Prompts',
            id: 83
          }
        ]
      }
    ]
  },
  {
    title: 'Monitoring',
    id: 84,
    href: '/monitoring',
    icon: <Icon.TrendingUp size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Supervisor',
        id: 85,
        subItems: [
          {
            title: 'Supervisor',
            href: '/monitoring/supervisor',
            permissionKey: 'Supervisor',
            id: 86
          },
          {
            title: 'Supervisor Role',
            href: '/monitoring/supervisor-role',
            permissionKey: 'Supervisor Role',
            id: 87
          }
        ]
      },
      {
        title: 'Auditor',
        id: 88,
        subItems: [
          {
            title: 'Auditor',
            href: '/monitoring/auditor',
            permissionKey: 'Auditor',
            id: 89
          },
          {
            title: 'Auditor Category',
            href: '/monitoring/auditor-category',
            permissionKey: 'Auditor Category',
            id: 90
          },
          {
            title: 'Manual Auditor',
            href: '/monitoring/manual-auditor',
            permissionKey: 'Manual Auditor',
            id: 91
          }
        ]
      }
    ]
  }
];

export const AdminSidebarData = [
  {
    title: 'Dashboard',
    href: '/admin-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Companies',
    href: '/companies',
    id: 2,
    icon: <Icon.Users size={20} />,
    collapisble: false
  },
  {
    title: 'VoiceBroadcast Billing',
    href: '/voicebroadcast-billing',
    id: 8,
    icon: <Icon.DollarSign size={20} />,
    collapisble: false
  },
  {
    title: 'Module Permissions',
    href: '/module-permission',
    id: 3,
    icon: <Icon.UserCheck size={20} />,
    collapisble: false
  },
  {
    title: 'Company Role',
    href: '/company-role',
    id: 4,
    icon: <Icon.Layers size={20} />,
    collapisble: false
  },
  {
    title: 'Timezone',
    href: '/timezone',
    id: 5,
    icon: <Icon.Clock size={20} />,
    collapisble: false
  },
  {
    title: 'Branding',
    href: '/branding',
    id: 6,
    icon: <Icon.Image size={20} />,
    collapisble: false
  },
  {
    title: 'Server Health',
    href: '/server-health',
    id: 7,
    icon: <Icon.Activity size={20} />,
    collapisble: false
  }
];

export const AuditorSidebarData = [
  {
    title: 'Dashboard',
    href: '/auditor-dashboard',
    id: 1,
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'Reports',
    id: 2,
    href: '/reports',
    icon: <Icon.FileText size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Audit Report',
        id: 3,
        subItems: [
          {
            title: 'Audit Report',
            href: '/reports/audit-report',
            permissionKey: 'Audit Report',
            id: 4
          }
        ]
      }
    ]
  }
];

export const IframeSidebarData = [
  {
    title: 'Dashboard',
    href: '/dashboard',
    id: 'dashboard',
    i18nTitle: 'dashboard',
    icon: <Icon.Home size={20} />,
    collapisble: false
  },
  {
    title: 'My Reports',
    href: '/my-reports',
    id: 'my-reports',
    i18nTitle: 'myReports',
    icon: <Icon.PhoneCall size={20} />,
    collapisble: true,
    subItems: [
      {
        title: 'Reports',
        i18nTitle: 'reports',
        id: 'reports',
        subItems: [
          {
            title: 'My Call History',
            i18nTitle: 'liveCallHistory',
            href: '/my-reports/my-callhistory',
            id: 'my-callhistory'
          },
          {
            title: 'My Missed Call Report',
            i18nTitle: 'myMissedCallReport',
            href: '/my-reports/my-missed-call-report',
            id: 'my-missed-call-report'
          }
        ]
      }
    ]
  }
];

export const IframeCrmSideBarData = [
  {
    title: 'Call In Progress',
    href: '/call-in-progress',
    id: 'call-in-progress',
    i18nTitle: 'callInProgress',
    icon: <Icon.PhoneCall size={20} />,
    collapisble: false
  },
  {
    title: 'My Call History',
    href: '/live-callhistory',
    id: 'live-callhistory',
    i18nTitle: 'liveCallHistory',
    icon: <Icon.PhoneCall size={20} />,
    collapisble: false
  }
];
